import HomePageLayout from '../../components/homepage-layout/HomePageLayout';

const HomePage = () => {
  return <HomePageLayout />;
};

export default HomePage;
